import { defineComponent, inject, ref, provide, reactive, watch, nextTick, onMounted, onBeforeUnmount, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, unref, createBlock, Fragment, renderList, resolveDynamicComponent, mergeProps, withCtx, toDisplayString, createCommentVNode, createVNode } from 'vue';
import { getPublishTimestamp, debounce } from '../../../utils/index.mjs';
import request from '../../../utils/request.mjs';
import { API_BASE, WEBSITE, PUBLIC_URL } from '../../../utils/getConstant.mjs';
import TvbLogoIcon from '../../Icon/Logo.vue.mjs';
import TvbUserIcon from '../../Icon/User.vue.mjs';
import SsoButton from '../../SsoButton/src/SsoButton.vue.mjs';
import TvbSearch from '../../Search/index.vue.mjs';
import Menu from '../../Menu/src/Menu.vue.mjs';
import TvbArrowIcon from '../../Icon/Arrow.vue.mjs';
import TvbMobileMenu from '../../Menu/src/Mobile.vue.mjs';
import TvbLoggedIcon from '../../Icon/Logged.vue.mjs';

const _hoisted_1 = ["href"];
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "tvb-header-menu-text" };
const _hoisted_4 = {
  key: 1,
  class: "tvb-header-menu-sub"
};
const _hoisted_5 = { class: "tvb-header-tools" };
const __default__ = defineComponent({
  name: "TvbHeader"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    maxWidth: null,
    fullPath: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const env = inject("env");
    const seo = inject("seo");
    const openMenuKey = ref("");
    const tvbHeaderMainRef = ref();
    const tvbHeaderMainMenuRef = ref();
    provide("openMenuKey", openMenuKey);
    provide("setOpenMenuKey", (MenuKey) => {
      openMenuKey.value = MenuKey;
    });
    const fullPaths = ref("");
    const header = reactive({
      menuToggle: false,
      maxWidth: props.maxWidth || "1712px",
      menus: {
        fullPath: props.fullPath || "",
        main: [],
        headerMain: [],
        slide: []
      }
    });
    provide("fullPath", fullPaths);
    watch(
      () => props.maxWidth,
      () => {
        header.maxWidth = props.maxWidth;
      }
    );
    watch(
      () => props.fullPath,
      () => {
        fullPaths.value = props.fullPath || "";
      }
    );
    watch(
      () => header.menuToggle,
      (menuToggle) => {
        window.document.querySelector("body").style.overflow = menuToggle ? "hidden" : "";
      }
    );
    watch(
      () => props.fullPath,
      () => computedActive()
    );
    const getMainMenus = () => {
      request.get(`/main-menu?_t=${getPublishTimestamp()}`, {
        baseURL: API_BASE(env || "prod")
      }).then(({ data }) => {
        var _a, _b, _c;
        header.menus.main = (_b = (_a = data == null ? void 0 : data.list) == null ? void 0 : _a.filter((l) => l.title)) != null ? _b : [];
        header.menus.headerMain = (_c = data == null ? void 0 : data.list) != null ? _c : [];
        nextTick(() => computedMainMenu());
      });
    };
    const computedMainMenu = () => {
      header.menus.headerMain = header.menus.main;
      nextTick(() => {
        var _a, _b;
        let menusWidth = 0;
        let headerMain = [];
        const otherMain = [];
        tvbHeaderMainRef.value.style.overflow = "hidden";
        const mainWidth = ((_a = tvbHeaderMainRef.value) == null ? void 0 : _a.clientWidth) || 0;
        tvbHeaderMainRef.value.style.overflow = "";
        (_b = tvbHeaderMainMenuRef.value) == null ? void 0 : _b.forEach((el, i) => {
          var _a2, _b2;
          menusWidth += ((el == null ? void 0 : el.clientWidth) || 0) + 26;
          if (mainWidth > menusWidth) {
            headerMain.push((_a2 = header == null ? void 0 : header.menus) == null ? void 0 : _a2.main[i]);
          } else {
            otherMain.push((_b2 = header == null ? void 0 : header.menus) == null ? void 0 : _b2.main[i]);
          }
        });
        if (otherMain.length) {
          otherMain.unshift(headerMain[headerMain.length - 1]);
          headerMain = headerMain.slice(0, headerMain.length - 1);
          headerMain.push({
            title: "\u66F4\u591A",
            jump_url: "",
            id: 1,
            sub_menu: otherMain
          });
        }
        header.menus.headerMain = headerMain;
        computedActive();
      });
    };
    const computedActive = () => {
      header.menus.headerMain.map((menu) => {
        menu.active = false;
        try {
          const url = new URL(menu == null ? void 0 : menu.jump_url);
          if (WEBSITE.includes(url.origin)) {
            menu.active = location.pathname === url.pathname;
            return menu;
          } else if (location.pathname && location.pathname !== "/") {
            menu.active = url.href.includes(location.pathname);
            return menu;
          } else {
            return menu;
          }
        } catch (error) {
          return menu;
        }
      });
    };
    onMounted(() => {
      getMainMenus();
      window.addEventListener("resize", debounce(computedMainMenu, 300, false));
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", debounce(computedMainMenu, 300, false));
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", {
        class: normalizeClass(["tvb-header", {}])
      }, [
        createElementVNode("main", {
          class: "tvb-header-container",
          style: normalizeStyle({ maxWidth: header.maxWidth })
        }, [
          createElementVNode("a", {
            href: unref(seo).logo_link || `${unref(PUBLIC_URL)(unref(env) || "prod")}/`,
            class: "tvb-header-logo",
            onClick: _cache[0] || (_cache[0] = (event) => emits("click", { event, event_label: "logo" }))
          }, [
            unref(seo).logo ? (openBlock(), createElementBlock("img", {
              key: 0,
              src: unref(seo).logo,
              alt: unref(seo).logo_alt_txt
            }, null, 8, _hoisted_2)) : (openBlock(), createBlock(TvbLogoIcon, { key: 1 }))
          ], 8, _hoisted_1),
          createElementVNode("nav", {
            ref_key: "tvbHeaderMainRef",
            ref: tvbHeaderMainRef,
            class: "tvb-header-menus"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(header.menus.headerMain, (menu, index) => {
              return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
                target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
              }, {
                ref_for: true,
                ref_key: "tvbHeaderMainMenuRef",
                ref: tvbHeaderMainMenuRef,
                class: ["tvb-header-menu", { active: menu.active }],
                href: (menu == null ? void 0 : menu.jump_url) || null,
                onClick: (event) => emits("click", { ...menu, event, event_label: "main-menu" })
              }), {
                default: withCtx(() => [
                  createElementVNode("h2", _hoisted_3, toDisplayString(menu == null ? void 0 : menu.title), 1),
                  (menu == null ? void 0 : menu.sub_menu.length) ? (openBlock(), createBlock(TvbArrowIcon, {
                    key: 0,
                    class: "tvb-header-menu-arrow"
                  })) : createCommentVNode("v-if", true),
                  (menu == null ? void 0 : menu.sub_menu.length) ? (openBlock(), createElementBlock("div", _hoisted_4, [
                    createVNode(Menu, {
                      menus: menu == null ? void 0 : menu.sub_menu,
                      "menu-key": menu == null ? void 0 : menu.title,
                      h: 3,
                      onClick: _cache[1] || (_cache[1] = (event) => emits("click", event))
                    }, null, 8, ["menus", "menu-key"])
                  ])) : createCommentVNode("v-if", true)
                ]),
                _: 2
              }, 1040, ["class", "href", "onClick"]);
            }), 128))
          ], 512),
          createElementVNode("div", _hoisted_5, [
            createVNode(TvbSearch, {
              "full-path": fullPaths.value,
              onClick: _cache[2] || (_cache[2] = (event) => emits("click", event))
            }, null, 8, ["full-path"]),
            createVNode(SsoButton, {
              type: "login-logout",
              class: "tvb-login-logout"
            }, {
              default: withCtx(({ isLogin }) => [
                createVNode(TvbUserIcon),
                isLogin ? (openBlock(), createBlock(TvbLoggedIcon, { key: 0 })) : createCommentVNode("v-if", true)
              ]),
              _: 1
            })
          ])
        ], 4),
        header.menus.main.length ? (openBlock(), createBlock(TvbMobileMenu, {
          key: 0,
          "full-path": __props.fullPath,
          menus: header.menus.main,
          h: 1,
          "menu-key": "mobile",
          onClick: _cache[3] || (_cache[3] = (event) => emits("click", event))
        }, null, 8, ["full-path", "menus"])) : createCommentVNode("v-if", true)
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Header.vue2.mjs.map
